import { Layout } from 'antd';
import styled from 'styled-components';

interface ILayoutContainer {
  isPageHome: boolean;
}

export const LayoutContainer = styled(Layout)<ILayoutContainer>`
  height: 100vh;
  overflow: hidden;

  .main-sidebar {
    border-right: 1px solid ${({ theme }) => theme.colors.border};
  }

  .main-sidebar {
    position: sticky !important;
    top: 0;
    left: 0;
    padding: 12px 0;
    background: ${({ theme }) => theme.colors.background} !important;
    height: 100vh;
  }

  .main-header-desktop {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .main-header-mobile {
    .menu-trigger {
      font-size: 18px;
      cursor: pointer;
      transition: color 0.3s;

      :hover {
        color: var(--primary-color);
      }
    }
  }

  .main-header-mobile-drawer {
    .ant-drawer-header {
      border-radius: 0;
      margin-bottom: -1px;
      border: none;

      .ant-drawer-header-title {
        display: inline-block;
        color: #fff;
        text-align: right;
      }

      svg {
        fill: #fff;
      }
    }

    .ant-drawer-content-wrapper {
      max-width: 340px;
    }

    .ant-drawer-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .app-item-title {
        margin-top: -24px;
      }

      .app-selected-title {
        line-height: 0;
        margin-top: -8px;
      }
    }
  }

  .ant-layout-sider-children {
    width: 100%;
  }

  .main-sidebar-collapsed div {
    opacity: 0;
  }

  .main-content {
    padding: 16px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    background: ${({ isPageHome, theme }) =>
      isPageHome ? theme.colors.background : theme.colors.content};
  }

  .main-footer {
    text-align: center;
    font-size: ${({ theme }) => theme.fontSizes.verySmall};
    color: ${({ theme }) => theme.colors.text2};
    margin-top: 40px;
    background: transparent;
  }

  .ant-alert-message {
    font-size: 0.8rem;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.primary};
  }

  .ant-alert-description {
    font-size: 0.8rem;
  }
`;

export const NotificationContent = styled.div`
  max-height: 500px;
  overflow-y: auto;
  min-width: 350px;

  &.mobile {
    min-width: 0;
    width: 100%;
    max-width: 92vw;
  }

  &.has-scrollbar {
    padding-right: 8px;
  }

  .ant-card {
    margin-bottom: 12px;
    transition: all 0.3s ease !important;
  }

  .ant-card:first-child {
    margin-top: 12px;
  }

  .ant-card-hoverable:hover {
    border-color: ${({ theme }) => theme.colors.border};
    transition: box-shadow 0.3s ease, border-color 0.3s ease !important;
    box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16),
      0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
  }

  .ant-card-head {
    padding: 0 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  }

  .ant-card-head-title {
    color: ${({ theme }) => theme.colors.text};
  }

  .ant-badge {
    padding: 2px 8px;
    border-radius: 8px;
    line-height: 1.5715;
    font-size: 14px;
  }

  .ant-badge.critical {
    color: #d2211d;
    border: 1px solid #d2211d;
  }

  .ant-badge.ok {
    color: #00be14;
    border: 1px solid #00be14;
  }

  .ant-card-body {
    padding: 12px;
  }

  .anticon-fall,
  .anticon-rise,
  .anticon-bell,
  .anticon-alert {
    color: ${({ theme }) =>
      theme.title === 'light' ? theme.colors.black : theme.colors.white};
  }

  .notification-card-extra {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .notification-inner-content {
    display: flex;
    flex-flow: column;
    gap: 8px;
  }

  .alarm-notification-item {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
  }

  .alarm-notification-item-icon {
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 8px;
  }

  .notification-card-divider {
    margin: 12px 0;
    background: 1px solid ${({ theme }) => theme.colors.border};
  }

  .notification-card-label {
    margin-bottom: 0px;
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
  }

  .notification-card-value {
    margin-bottom: 0px;
    color: ${({ theme }) => theme.colors.text};
    font-weight: 500;
    font-size: 16px;
  }

  .notification-card-date-time {
    margin-bottom: 0px;
    color: ${({ theme }) => theme.colors.text1};
  }

  .virtual-list-item span {
    background: none !important;
  }
`;
